<template>
  <div class="login-wrap">
      <!-- 头部菜单 -->
    <el-header class="index-header" style="height: 8%;background-color: #fff;">
      <img class="logoimg" src="../../assets/img/logo.png" alt="">

      <!-- <el-link href="https://www.huawan.com" target="_blank">官网</el-link> -->
    </el-header>
    <!-- 表单 -->
    <el-main class="content">
      <el-form  class="login-container">
          <el-tabs v-model="activeName"  :stretch="true" @tab-click="handleClick">
              <el-tab-pane label="密码登录" name="first" v-if="wxshow">
                <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
            
                  <el-form-item prop="username">
                    <el-input type="text" v-model="ruleForm.username" auto-complete="off" placeholder="用户名/邮箱/手机号"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input type="password" show-password v-model="ruleForm.password" auto-complete="off" placeholder="密码"></el-input>
                  </el-form-item>
                </el-form>
                </el-tab-pane>
                
                <el-tab-pane label="验证码登录" name="second" v-if="wxshow">
                  
                <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
            
                  <el-form-item prop="telephone">
                    <el-input type="text" v-model="ruleForm.telephone" auto-complete="off" placeholder="手机号码"></el-input>
                  </el-form-item>
                  <el-form-item prop="captcha">
                    <el-input placeholder="验证码" v-model="ruleForm.captcha" class="input-with-select">
                      <el-button slot="append" v-show="show" @click="captchaHandle(2)" >发送验证码</el-button>
                      <el-button slot="append" v-show="!show">{{count}} s</el-button>
                    </el-input>
                  </el-form-item>

                </el-form>
              </el-tab-pane>

              <el-tab-pane label="微信扫码登录" name="third" v-if="!wxshow">
                <!-- <div class="clg-mod-txt">
                  请使用微信扫一扫登录 刷新 <i class="el-icon-refresh-right" @click="qrCodeGeneration"></i>
                </div> -->

                <el-form-item prop="ewm" style=" display: flex;justify-content: center;">
                  <div class="qrCode" v-show="qrCodeExpire">
                    二维码已过期&nbsp;
                    <el-link @click="qrCodeGeneration">刷新<i class="el-icon-refresh"></i></el-link>
                  </div>
                  <div style="color: red;" v-show="errorMessageShow">
                    您的账号尚未绑定微信
                  </div>
                  <div ref="qrCodeUrl"></div>
                </el-form-item>
              </el-tab-pane>
          </el-tabs>
          <el-form-item style="width:100%;" v-if="wxshow">
            <el-button type="primary" style="width:100%;" v-if="activeName=='first'" @click="captchaHandle(1)" :loading="logining">登录</el-button>
            <el-button type="primary" style="width:100%;" v-if="activeName=='second'" @click="submitForm2()" :loading="logining">登录</el-button>
          </el-form-item>
          <el-form-item style="width:100%;">
            <div class="login-bottom">
              <div class="wxlogin">
                <div v-if="wxshow">
                  <div @click="toWxLogin" style="display: flex; align-items: center;">
                    <svg t="1649338821333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2260" width="32" height="32">
                      <path d="M337.387283 341.82659c-17.757225 0-35.514451 11.83815-35.514451 29.595375s17.757225 29.595376 35.514451 29.595376 29.595376-11.83815 29.595376-29.595376c0-18.49711-11.83815-29.595376-29.595376-29.595375zM577.849711 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763zM501.641618 401.017341c17.757225 0 29.595376-12.578035 29.595376-29.595376 0-17.757225-11.83815-29.595376-29.595376-29.595375s-35.514451 11.83815-35.51445 29.595375 17.757225 29.595376 35.51445 29.595376zM706.589595 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763z" fill="#28C445" p-id="2261"></path>
                      <path d="M510.520231 2.959538C228.624277 2.959538 0 231.583815 0 513.479769s228.624277 510.520231 510.520231 510.520231 510.520231-228.624277 510.520231-510.520231-228.624277-510.520231-510.520231-510.520231zM413.595376 644.439306c-29.595376 0-53.271676-5.919075-81.387284-12.578034l-81.387283 41.433526 22.936416-71.768786c-58.450867-41.433526-93.965318-95.445087-93.965317-159.815029 0-113.202312 105.803468-201.988439 233.803468-201.98844 114.682081 0 216.046243 71.028902 236.023121 166.473989-7.398844-0.739884-14.797688-1.479769-22.196532-1.479769-110.982659 1.479769-198.289017 85.086705-198.289017 188.67052 0 17.017341 2.959538 33.294798 7.398844 49.572255-7.398844 0.739884-15.537572 1.479769-22.936416 1.479768z m346.265896 82.867052l17.757225 59.190752-63.630058-35.514451c-22.936416 5.919075-46.612717 11.83815-70.289017 11.83815-111.722543 0-199.768786-76.947977-199.768786-172.393063-0.739884-94.705202 87.306358-171.653179 198.289017-171.65318 105.803468 0 199.028902 77.687861 199.028902 172.393064 0 53.271676-34.774566 100.624277-81.387283 136.138728z" fill="#28C445" p-id="2262"></path>
                    </svg> <span style="padding-left:10px">微信扫码登录</span>

                  </div>
                </div>

                <!-- 其他登录方式 -->
                <div class="clg-back-mod" v-if="!wxshow">
                  <a href="#" @click="toOtherLogin"><i class="el-icon-arrow-left"></i>切换其他登录方式</a>
                </div>
              </div>
              <div class="wjmm"  v-if="wxshow">
                <span><el-link type="info" @click="goTo('/login/forgetPassword')" :underline="false">忘记密码</el-link></span>
                <el-divider direction="vertical"></el-divider>
                <span><el-link type="info" @click="goTo('/register')" :underline="false">免费注册</el-link></span>
              </div>

            </div>

          </el-form-item>

      </el-form>
    </el-main>
    

    
    <!-- 登录验证码 -->
    <transition name="fade">
      <jigsaw-captcha
        ref="captcha"
        v-if="captchaVisible"
        :show="captchaVisible"
        :register="registerCaptcha"
        :login="loginCaptcha"
        @close="onCloseCaptcha"
      ></jigsaw-captcha>
    </transition>
    <FooterItem ></FooterItem>

  </div>
</template>
<script type="text/ecmascript-6">
import QRCode from 'qrcodejs2'
// 导入组件
import JigsawCaptcha from '@/components/CaptchaJigsaw'
import FooterItem from '../../components/footer.vue'

import { login, captcha, scan, smsLogin, register, checkloginscan } from '../../api/userMG'
import { setCookie, getCookie, del } from '../../utils/util'
import md5 from 'js-md5'
import Qs from 'qs';


export default {
  name: 'login',
  // 注册组件
  components: {
    JigsawCaptcha,
    FooterItem
  },
  data() {
    return {
      errorMessageShow: false,
      ticket: '',
      timer: null,
      captchaVisible: false,
      qrCodeExpire: false, //二维码过期
      wxshow: true,
      show: true,
      count: '',
      timer: null,
      activeName: 'first',
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
        imgCode: '',
        randomStr: '',
        codeimg: '',
        telephone: '',
        captcha: '',
        t:0
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        imgCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        telephone: [{ required: false}],
        captcha: [{ required: false}],
      },
      tel:{
        dialogShow: false,
        imgCode: '',
        codeimg: '',
        t:0
      },
      captchaImgCode: '' //短信验证图形验证码
    }
  },
  
  // 创建完毕状态(里面是操作)
  created() {
    const query = Qs.parse(location.search.substring(1))
    let accessToken = query.accessToken;
    // console.log("token=>"+accessToken)
    // alert("token=>"+accessToken)
    if(accessToken){
      this.$store.commit(`setToken`, accessToken);
      this.$router.push({ path: '/dashboard' })
    }
    // 获取图形验证码
    // this.getcode(1)
    // 获取存在本地的用户名密码
    this.getuserpwd()
  },
  watch:{
    // qrCodeExpire:{
    //     handler(val){
    //         if(val){
    //           clearInterval(this.timer)
    //         }
            
    //     },
    //     deep: true,
    //     immediate:true
    // }
  },
  // 里面的函数只有调用才会执行
  methods: {
    // getcode(index){
    //   if(index==1){
    //     this.ruleForm.t = (new Date()).getTime()
    //     this.ruleForm.codeimg = process.env.GATEWAY_URL+'/api/op/getImgCode?t='+this.ruleForm.t
    //   }else if(index==2){
    //     this.tel.t = (new Date()).getTime()
    //     this.tel.codeimg = process.env.GATEWAY_URL+'/api/op/getImgCode?t='+this.tel.t
    //   }

    // },
    handleClick(tab, event) {
      // this.ruleForm.username=''
    },
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(token, sliceX, resolve, reject) {
      let _valid = true;
      this.$refs['ruleForm'].validate(valid => {
            _valid = valid
        })
      const params = {
          username: this.ruleForm.username,
          password: this.ruleForm.password,
          token: token,
          sliceX: sliceX
        }
      
      if (_valid) {
        this.logining = true
        login(params).then(res => {
          resolve(res)
          if (res.code==0) {
            // if (this.rememberpwd) {
            //   //保存帐号到cookie，有效期7天
            //   setCookie('user', this.ruleForm.username, 7)
            //   //保存密码到cookie，有效期7天
            //   setCookie('pwd', this.ruleForm.password, 7)
            // } else {
            //   delCookie('user')
            //   delCookie('pwd')
            // }
            //如果请求成功就让他2秒跳转路由
            setTimeout(() => {
              this.logining = false
              // 缓存token
              this.$store.commit(`setToken`, res.data.token);
              // 缓存用户个人信息
              this.$router.push({ path: '/dashboard' })
            }, 1000)
          } else if(res.code=='8888888'){
            reject(res)
          }else {
            this.captchaVisible = false
            this.$message.error(res.message)
            this.logining = false
            return false
          }
        }, err => {
            reject(err)
          })
      } else {
        // 获取图形验证码
        this.logining = false
        return false
      }
    },
    //手机验证码登录
    submitForm2() {
      const params = {
        username: this.ruleForm.telephone,
        password: this.ruleForm.captcha,
        type:'sms'
      }
      this.logining = true
      smsLogin(params).then(res => {
        if (res.code==0) {
          //如果请求成功就让他2秒跳转路由
          setTimeout(() => {
            this.logining = false
            // 缓存token
            this.$store.commit(`setToken`, res.data.token);
            // 缓存用户个人信息
            this.$router.push({ path: '/dashboard' })
          }, 1000)
        } else {
          this.$message.error(res.message)
          this.logining = false
          return false
        }
      })
    },
    captchaHandle(index){
      if(index==1){
        //登录
        let _valid = true;
        this.$refs['ruleForm'].validate(valid => {
            _valid = valid
        })
        if(!_valid){
          return;
        }else{
          this.captchaVisible = true
        }
      }else if(index==2){
        //发送短信
        if(!this.ruleForm.telephone){
          this.$message.warning('请输入手机号码')
          return
        }else{
          const phoneReg = /(^1[3|4|5|7|8]\d{9}$)|(^09\d{8}$)/;
          if(!phoneReg.test(this.ruleForm.telephone)){
            this.$message.warning('请输入有效的手机号码')
            return
          }else{
            this.captchaVisible = true
          }
        }
      }
     
    },
    getCaptcha() {
      if(!this.tel.imgCode){
        this.$message.warning('请输入图形验证码')
        return
      }
      //发送手机验证码
      captcha({mobile:this.ruleForm.telephone,imgCode: this.tel.imgCode, t: this.tel.t}).then(res=>{
        if(res.code==0){
          this.$message.success(res.message)
          this.tel.dialogShow = false
          //倒计时
          const TIME_COUNT = 60
          if (!this.timer) {
            this.count = TIME_COUNT
            this.show = false
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--
              } else {
                this.show = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        }
      })
    },
    toWxLogin() {
      this.wxshow = !this.wxshow
      this.activeName = 'third'
      this.qrCodeGeneration()
    },
    toOtherLogin() {
      this.wxshow = !this.wxshow
      this.activeName = 'first'

      if(this.wxshow){
        clearInterval(this.timer);
      }
    },
    // 二维码生成
    qrCodeGeneration() {
        this.qrCodeExpire = false
        // 二维码弹框显示
        if(this.$refs.qrCodeUrl){
          this.$refs.qrCodeUrl.innerHTML = ""
        }
        // 生成二维码
        const params = {action:'login'}
        scan(params).then(res=>{
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: res.url, // 需要转换为二维码的内容
                width: 150,
                height: 150,
                // render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                colorDark: "#000000", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
          });

          this.ticket = res.ticket
          this.setTimer();//开启定时任务
          
        })
        
    },
     /**定时器*/
     setTimer() {
      this.timer = setInterval(() => {
        this.checkQrCode();
      }, 5000);
    },
    checkQrCode() {
      let that = this;
      checkloginscan({"ticket": this.ticket}).then(res=>{
        if(res.code==1){
          clearInterval(that.timer);//扫码成功后清空定时器
          that.$message.success('扫码成功')
          // 缓存token
          that.$store.commit(`setToken`, res.data);
          // 缓存用户个人信息
          that.$router.push({ path: '/dashboard' })
        }else if(res.code==-1){
          clearInterval(that.timer);//扫码超时后清空定时器
					that.qrCodeExpire = true;//出现刷新的遮罩
        }else if(res.code==-2){
          clearInterval(that.timer);//扫码超时后清空定时器
					// that.$message.success(res.message)
          that.errorMessageShow = true
        }
      }).catch(err=>{
          clearInterval(that.timer);
      })
    },
    goTo(url){
        this.$router.push(url)
    },
    
    /**
     * 注册验证码
     */
     registerCaptcha () {
      return new Promise((resolve, reject) => {
        register().then(resp => {
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * 拼图校验与登录
     */
    loginCaptcha (token, sliceX) {
      return new Promise((resolve, reject) => {
        if(this.activeName=='first'){
            this.submitForm(token, sliceX, resolve, reject)
        }else if(this.activeName=='second'){

          let form = {
            username: this.ruleForm.telephone,
            token: token,
            sliceX: sliceX
          }
          captcha(form).then(resp => {
            resolve(resp)
            if(resp.code==0){
              this.$message.success('发送成功')
              //倒计时
              const TIME_COUNT = 60
              if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--
                  } else {
                    this.show = true
                    clearInterval(this.timer)
                    this.timer = null
                  }
                }, 1000)
              }
            }else{
              if(resp.code==1001){
                this.$message.warning(`请勿频繁发送验证码`)
              }
            }
          }, err => {
            reject(err)
          })
        }
        
      })
    },
    
    /**
     * 关闭弹出验证码
     */
     onCloseCaptcha () {
      this.captchaVisible = false
    }

},
  // 销毁前状态(里面是操作)
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style scoped>
 @media only screen and (max-width: 500px) {
  
  .login-container {
    border-radius: 10px;
    margin-top: 10px;
    height: 400px;
    padding: 30px 35px 0px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    text-align: left;
    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  }
 }
 
@media only screen and (min-width: 500px) {

  .login-container {
    border-radius: 10px;
    /* margin: 0px auto; */
    margin-top: 10px;
    margin-left: 8%;
    width: 350px;
    height: 400px;
    /* padding: 30px 35px 15px 35px; */
    padding: 30px 35px 0px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    text-align: left;
    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  }
}
.el-main{
  padding:0px;
  height: 84%;
}
.content{
  background-image: url('../../assets/img/background.jpg');
  background-repeat: no-repeat;
    /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */
    background-attachment: fixed;
    /* 让背景图基于容器大小伸缩 */
    background-size: cover;
    /* 设置背景颜色，背景图加载过程中会显示背景色 */
    background-color: #FFFFFF;
}
.logoimg {
  height: 36px;
  position: absolute;
  top: 7px;
  /* left: 67px; */
  margin-left: 30px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding-top: 1%; */
  /* background-image: url('https://www.huawan.com/uploadfile/202208/b048e0cea7c010c.jpg'); */
  /* background-color: #f5f6f8; */
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 0px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}

.login-bottom {
  display: flex;
  color: #999;
}
.wxlogin {
  width: 50%;
  display: flex;
  align-items: center;
}
/* .wxlogin a {
  align-items: center;
  text-decoration: none;
} */
.wjmm {
  width: 50%;
  text-align: right;
}
.wxewmImg {
  width: 70%;
  height: 70%;
  text-align: center;
}
.clg-mod-txt {
  color: #666;
  font-size: 14px;
  /* line-height: 20px; */
  margin-bottom: 15px;
  text-align: center;
}
.clg-back-mod a {
  color: #00a4ff;
  text-decoration: none;
}
</style>
<style>
.el-tabs__item {
  font-size: larger;
}
.el-tabs__header {
  margin-bottom: 55px;
}
.qrCode{
    position: absolute;
    background-color: white;
    width: 150px;
    height: 150px;
    opacity: 0.85;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    font-weight: 500;
    line-height: 16px;
}

</style>


// WEBPACK FOOTER //
// src/views/login/login.vue